import { getCoreRowModel, getSortedRowModel, useReactTable } from "@tanstack/react-table";
import { Table } from "../../components/table/Table";
import { useAuditLogs } from "./api/useAuditLogs";
import { createColumnBuilder } from "../../components/table/columnBuilder";
import type { AuditLog } from "../../zodios/apiDefinitions/api/auditLogs";
import moment from "moment";
import { css } from "../../../styled-system/css";
import { VStack } from "../../../styled-system/jsx";
import { TextAreaField } from "../../components/fields/base/TextAreaField";

const columnHelper = createColumnBuilder<AuditLog>();

const columns = [
  columnHelper.accessor("timestamp", {
    cell: (info) => moment(info.getValue()).format("YYYY-MM-DD HH:mm:ss"),
  }),
  columnHelper.accessor("ref_id", {
    header: "Campaign ID",
  }),
  columnHelper.accessor("action", {}),
  columnHelper.accessor("payload", {
    cell: function Cell(info) {
      return (
        <VStack alignItems="start" width="100%">
          <TextAreaField
            className={css({ width: "100%", height: "100px" })}
            value={JSON.stringify(info.getValue(), null, 2)}
            isReadOnly
          />
        </VStack>
      );
    },
    size: 250,
  }),
];

interface Props {
  entity: string;
  ids: string[] | number[];
}

export function AuditLog({ entity, ids }: Props) {
  const auditLogsQuery = useAuditLogs({
    entity,
    ids,
  });

  const table = useReactTable({
    data: auditLogsQuery.data || [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    enableRowSelection: false,
  });

  return <Table table={table} />;
}
